"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.newRunError = exports.newCleanupError = exports.newCompilerError = exports.newBuilderError = exports.newActionBuilderError = void 0;
const __1 = require("..");
const errors_1 = require("../interfaces/errors");
const MALLOC_CORE_ERROR_MARKER = 0x40000000;
const MIN_MALLOC_ERROR_CODE = MALLOC_CORE_ERROR_MARKER;
const MAX_MALLOC_ERROR_CODE = MALLOC_CORE_ERROR_MARKER + 200;
const MALLOC_ACTION_UNEXPECTED_NUMBER_RETURNS = 420696;
const newActionBuilderError = (actionTypeUID, actionName, actionIdx, message, filledConstruction) => {
    return {
        mallocErrorMarker: "MALLOC ERROR MARKER",
        type: errors_1.MallocErrorTypes.MALLOC_ACTION_BUILDER,
        actionName,
        message: `An error occurred with ${actionName}: ${message}`,
        actionIndex: actionIdx,
        actionTypeUID,
        filledNonSpecificConstruction: filledConstruction,
    };
};
exports.newActionBuilderError = newActionBuilderError;
const newBuilderError = (message) => {
    return {
        mallocErrorMarker: "MALLOC ERROR MARKER",
        type: errors_1.MallocErrorTypes.MALLOC_BUILDER,
        message,
    };
};
exports.newBuilderError = newBuilderError;
const newCompilerError = (message) => {
    return {
        mallocErrorMarker: "MALLOC ERROR MARKER",
        type: errors_1.MallocErrorTypes.MALLOC_COMPILER,
        message,
    };
};
exports.newCompilerError = newCompilerError;
const newCleanupError = (e, skippedPreflight) => {
    const eStr = e.toString();
    const logInfo = skippedPreflight
        ? extractLogInfPreflight(eStr)
        : extractLogInfoPreflight(eStr);
    if (!logInfo)
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code: -1,
            message: `An error occurred in closing the ephemeral accounts: ${e} `,
            mallocErrorMarker: "MALLOC ERROR MARKER",
            contractType: "Other",
        };
    const contractType = getContractType(logInfo.code);
    if (contractType === "Malloc Action")
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code: -1,
            message: `An error occurred in closing the ephemeral action result accounts: ${e} `,
            mallocErrorMarker: "MALLOC ERROR MARKER",
            contractType,
        };
    else
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code: -1,
            message: `An error occurred in closing the ephemeral accounts: ${e} `,
            mallocErrorMarker: "MALLOC ERROR MARKER",
            contractType,
        };
};
exports.newCleanupError = newCleanupError;
/**
 * Extract error information from the contract
 * This should be able to this both when preflight is on and off
 */
const newRunError = (e, actionMap, skippedPreflight, actions, txType, actionIdx, isMainActionCall) => {
    var _a, _b, _c;
    const actionName = actionIdx !== undefined ? actions[actionIdx].actionName : undefined;
    console.log("Error occurred with tx type", txType);
    const eStr = (_b = (_a = e === null || e === void 0 ? void 0 : e.err) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : e.toString();
    const logInfo = skippedPreflight
        ? extractLogInfPreflight(eStr)
        : extractLogInfoPreflight(eStr);
    if (!logInfo || txType === "unknown") {
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code: -1,
            message: `An error occurred: ${eStr}`,
            contractType: "Other",
            actionName,
            actionIdx,
            mallocErrorMarker: "MALLOC ERROR MARKER",
        };
    }
    const { code } = logInfo;
    // This code is handled separately as it is caught outside of the idl generated errors
    if (code === MALLOC_ACTION_UNEXPECTED_NUMBER_RETURNS) {
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code: code,
            message: `The action returned an unexpected number of return tokens`,
            contractType: "Malloc Action",
            actionName,
            mallocErrorMarker: "MALLOC ERROR MARKER",
            actionIdx,
            name: "UnexpectedNumberReturns",
        };
    }
    const contractType = getContractType(code, actionIdx);
    if (contractType === "Other") {
        const message = actionIdx
            ? `An unexpected error occurred from which originated from ${actions[actionIdx].actionName}`
            : `An unexpected error occured: ${eStr}`;
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code,
            message,
            contractType: "Other",
            mallocErrorMarker: "MALLOC ERROR MARKER",
            actionName,
            actionIdx,
        };
    }
    else if (contractType === "Malloc Action") {
        let message;
        const idx = actionIdx;
        const uid = actions[idx].actionTypeUID;
        let idlError;
        if (isMainActionCall) {
            idlError = (_c = actionMap[uid].idl) === null || _c === void 0 ? void 0 : _c.errors.find((e) => e.code === code);
            message = idlError
                ? `An error occurred in action ${actions[idx].actionName}: ${idlError.msg}`
                : `An error occurred in action ${actions[idx].actionName}`;
        }
        else {
            message = `An error occurred in the setup to action ${actionIdx[idx].actionName}: ${eStr}`;
        }
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code: code,
            message,
            contractType: "Malloc Action",
            mallocErrorMarker: "MALLOC ERROR MARKER",
            actionIdx: idx,
            actionName,
            name: idlError === null || idlError === void 0 ? void 0 : idlError.name,
        };
    }
    else if (contractType === "Malloc Core") {
        // The idl expects codes to start from 300
        const idlCode = (~MALLOC_CORE_ERROR_MARKER & code) + 300; // remove the upper bit marker for malloc error
        const idlError = __1.MallocIdl.errors.find((e) => e.code === idlCode);
        const message = idlError
            ? actionIdx
                ? `An error occurred when calling ${actions[actionIdx].actionName}: ${idlError.msg}`
                : `An error occurred: ${idlError.msg}`
            : actionIdx
                ? `An unexpected error occurred when calling ${actions[actionIdx].actionName}`
                : `An unexpected error occurred`;
        return {
            type: errors_1.MallocErrorTypes.MALLOC_RUNNER,
            code: code,
            message,
            contractType: "Malloc Core",
            mallocErrorMarker: "MALLOC ERROR MARKER",
            actionIdx,
            actionName,
            name: idlError === null || idlError === void 0 ? void 0 : idlError.name,
        };
    }
    else {
        throw "Error with error builder for new run error";
    }
};
exports.newRunError = newRunError;
const getContractType = (code, actionIdx) => {
    let contractType;
    if ((code < 400 && code >= 300) ||
        code === MALLOC_ACTION_UNEXPECTED_NUMBER_RETURNS) {
        contractType = "Malloc Action";
    }
    else if (code >= MIN_MALLOC_ERROR_CODE && MAX_MALLOC_ERROR_CODE >= code) {
        contractType = "Malloc Core";
    }
    else {
        contractType = "Other";
    }
    return contractType;
};
const extractLogInfoPreflight = (log) => {
    const matchesCodePreflight = log.match(/custom\sprogram\serror:\s(\w+)/);
    let code;
    if (matchesCodePreflight && matchesCodePreflight.length >= 2) {
        const codeStr = matchesCodePreflight[1];
        code = parseInt(codeStr, 16);
    }
    else {
        return undefined;
    }
    return {
        code,
    };
};
const extractLogInfPreflight = (log) => {
    const matchesCodePreflight = log.match(/"Custom":([0-9]+)\}/);
    let code;
    if (matchesCodePreflight && matchesCodePreflight.length >= 2) {
        const codeStr = matchesCodePreflight[1];
        code = parseInt(codeStr);
    }
    else {
        return undefined;
    }
    return {
        code,
    };
};
